export const i18nConfig = {
  locales: ['en', 'de', 'es', 'it'],
  defaultLocale: 'en',
} as const;

/**
 * Global default for next-intl date/time formatting, so server and client
 * render the same markup. Property-scoped providers (e.g. check-in) override
 * it with the property's own time zone.
 */
export const DEFAULT_TIME_ZONE = 'Europe/Berlin';

export type Locale = (typeof i18nConfig.locales)[number];
